export enum AppContextRole {
  Learner = "learner",
  Instructor = "instructor",
  Admin = "admin",
}


export interface AppContext {
  role: AppContextRole;
}